export class DocumentFileFormat {
    DocumentFileFormatId: number;
    FileExtension: string;
    MIMEMapping: string;
    PhysicalRootFilePath: string;
}
